import React, { useEffect, useState, useContext, useRef } from 'react'
import { Marker } from 'maplibre-gl/dist/maplibre-gl-csp'

import MapContext from './MapContext'

import { useSettings } from '../../slices/settings'
import { useGeolocation } from '../../slices/geolocation'
import { addMessage } from '../../slices/ui'
import { setMapView } from '../../slices/map'


const GeolocationMarker = (props) => {
  const { lnglat, heading } = useGeolocation()
  const { geolocation } = useSettings()
  const [orienatation, setOrientation] = useState(null)
  const map = useContext(MapContext)
  const marker = useRef()
  const element = useRef()
  const markerRotation = geolocation && orienatation
  const isOutOfMap = lnglat && map && !map.maxBounds.contains(lnglat)

  useEffect(()=>{
    if (isOutOfMap || !window.DeviceOrientationEvent ) return

    const orienatationHandler = (e) => {
      const orienatation = Math.round(e.webkitCompassHeading || Math.abs(e.alpha - 360)) - 90;  
      setOrientation(orienatation)
    }

    if (window.DeviceOrientationEvent.requestPermission) {
      window.DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response === "granted") {
            window.addEventListener("deviceorientation", orienatationHandler, true);
          }         
        })
    } else {
      window.addEventListener("deviceorientationabsolute", orienatationHandler, true);
    }

    return () => {
        window.removeEventListener(
            window.DeviceOrientationEvent.requestPermission ? "deviceorientation" : "deviceorientationabsolute", 
            orienatationHandler, true) 
        setOrientation(null)
    }
  }, [isOutOfMap])

  useEffect(()=>{

    if (!map || !lnglat || isOutOfMap) return

    const heading = document.createElement('div');
    element.current = document.createElement('div'); 
    element.current.append(heading)
    element.current.classList.add("map__geolocation__marker");
    marker.current = new Marker({element: element.current, rotationAlignment:'map'})
    marker.current.setLngLat([0, 0])
    marker.current.addTo(map)

    return () => {
      map && marker.current && marker.current.remove()
      marker.current = null
    }
  }, [map, isOutOfMap, lnglat])


  useEffect(()=>{
    if (!marker.current || !lnglat) return
    marker.current.setLngLat(lnglat)
  }, [lnglat])

  useEffect(()=>{
    if (!marker.current) return
    if (markerRotation !== null) {
      element.current.classList.add("heading");
    } else {
      element.current.classList.remove("heading");
    }
    marker.current.setRotation(markerRotation || 0)
  }, [markerRotation])

  return null

}

export default GeolocationMarker
